/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeries/view.blocks to change it.
import Body from './Body/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImageSeries({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/ImageSeries"
  
}) {
  return (<React.Fragment
>
<Body
  viewPath={`${viewPath}/Body`}
/>
{children}
</React.Fragment>)
}